import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { TClientDetailsClientInfo, ClientDetailsScreen } from 'types/state';
import { SidebarModalSectionComponent } from 'design/sidebarModal';
import { TextComponent } from 'design/text/textComponents';
import {
  SidebarModalNavigationControlComponent,
  SidebarModalNavigationLayoutComponent,
} from 'design/sidebarModalNavigation';

type Props = {
  activeScreen: ClientDetailsScreen;
  clientInfo: TClientDetailsClientInfo;
  onTabClick(nextScreen: ClientDetailsScreen): void;
};

export const ClientDetailsContent: React.FC<Props> = (props) => {
  const { activeScreen, clientInfo, children, onTabClick } = props;

  const { clientDetails: intl } = useIntlDictionary();

  const handleSummaryTabClick = React.useCallback(() => {
    onTabClick({
      name: 'Summary',
    });
  }, [onTabClick]);

  const handleProductsTabClick = React.useCallback(() => {
    onTabClick({
      name: 'Products',
    });
  }, [onTabClick]);

  const handlePaymentsTabClick = React.useCallback(() => {
    onTabClick({
      name: 'Payments',
    });
  }, [onTabClick]);

  return (
    <>
      <SidebarModalSectionComponent
        theme="head"
        content={
          <TextComponent size="mpp" weight="medium">
            {clientInfo.company}
          </TextComponent>
        }
        actions={null}
        navigation={
          <SidebarModalNavigationLayoutComponent>
            <SidebarModalNavigationControlComponent
              onPress={handleSummaryTabClick}
              active={activeScreen.name === 'Summary'}
            >
              <TextComponent>{intl.tabs.summaryTabLabel}</TextComponent>
            </SidebarModalNavigationControlComponent>
            <SidebarModalNavigationControlComponent
              onPress={handleProductsTabClick}
              active={activeScreen.name === 'Products'}
            >
              <TextComponent>{intl.tabs.productsTabLabel}</TextComponent>
            </SidebarModalNavigationControlComponent>
            <SidebarModalNavigationControlComponent
              onPress={handlePaymentsTabClick}
              active={activeScreen.name === 'Payments'}
            >
              <TextComponent>{intl.tabs.paymentsTabLabel}</TextComponent>
            </SidebarModalNavigationControlComponent>
          </SidebarModalNavigationLayoutComponent>
        }
      />
      {children}
    </>
  );
};
